<!-- @format -->

@if (isSeePriceInCart && pricingInfo) {
	<div class="price-text">See Price In Cart</div>
}
@if (!isSeePriceInCart && pricingInfo) {
	<div
		[ngClass]="{ clearance: isClearance }"
		class="price-text">
		@if (pricingInfo.minofferprice) {
			{{ pricingInfo.minofferprice | currency }}
			@if (pricingInfo.maxofferprice !== pricingInfo.minofferprice) {
				<span> - {{ pricingInfo.maxofferprice | currency }}</span>
			}
		}
		<!-- Favorites sku product card pricing -->
		@if (!pricingInfo.minofferprice) {
			{{ pricingInfo.offerPrice | currency }}
		}
	</div>
}
